import { FC, ReactElement } from 'react';
import { Navigate } from 'react-router';
import { useUserStore } from '../store/userStore';

export const ProtectedRoute: FC<{ children: ReactElement }> = ({
  children,
}) => {
  const isAuthenticated = useUserStore().isLoggedIn;

  return isAuthenticated ? children : <Navigate to={'/signin'} />;
};
